import Enum from "../../../../../../enums/Enum";

const FeelEnum = new Enum({
    INDIFFERENT: {name: "Indifferent"},
    EASILYPREVENTABLE: {name: "Easily Preventable"},
    FRUSTRATED: {name: "Frustrated"},
    SELFINFLICTED: {name: "Self-inflicted"}
});

export default FeelEnum;